
















































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import moment from 'moment';
import TextField from '@/reusable/Form/TextField.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
    MantenedorGridSinCodigo,
    MantenedorGrid,
  },
})
export default class VerCrearModal extends Vue {
  @Prop({ default: true }) show: boolean;
  id_equipo: any;
  dictionaryFormErrors: any = {};
  respuesta: any;
  optionslist: any = [
    { text: 'EQUIPO', value: false },
    { text: 'PERIFÉRICO', value: true },
  ];

  optionslist_2: any = [
    { text: 'ACTIVO', value: null },
    { text: 'INACTIVO', value: 1 },
  ];
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  plataforma: any = null;
  tipoeqcuenta_inet_new: any = null;
  nuevo_tipoeqid: any = null;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Crear Equipo',
      visible: true,
      step: 1,
      title: 'Crear Equipo',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  readonly funcionalidad: Funcionalidades = Funcionalidades.EditarVehiculos;

  async editar() {
    this.respuesta = await this.$validator.validateAll();
    let self = this;
    this.loadingService.showLoading();

    return fetchReportesSerie(
      {
        usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
        usuariorut_alta: JSON.parse(localStorage.getItem('user'))
          .rutClienteDefecto,
        tipoeqid: this.id_equipo,
        tipoeqname: this.formFields.nombreEquipo.value.toString().toUpperCase(),
        tipoeqname_crm: this.formFields.nombreCRM.value
          .toString()
          .toUpperCase(),
        tipoeqname_inet: this.formFields.nombreINET.value
          .toString()
          .toUpperCase(),
        tipoeqcodigo: this.formFields.tipoeqcodigo.value
          .toString()
          .toUpperCase(),
        tipoeqperiferico: this.formFields.clase.value,
        tipoeqestado: this.formFields.estado.value,
        tipoeqseriado: this.formFields.seriado.value,
        tipoeqid_r: this.formFields.tipoeqid_r.value,
        tipoeqcuenta_inet: this.formFields.tipoeqcuenta_inet.value,
      },
      'conecta_matriz_producto/crear_equipo'
    )
      .then((data: any) => {
        if (this.respuesta == false) {
          self.$snotify.error('EL formulario presenta errores.', {
            timeout: 3000,
          });
          return;
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.nuevo_tipoeqid = data.data.tipoeqid;
          this.loadedSeries.forEach(async serie => {
            const nuevo_tipoeqid = this.nuevo_tipoeqid;
            // Llamar a insertar_cuentasInet para cada elemento
            await this.insertar_cuentasInet(
              serie.cuentaInet,
              serie.plataformaid,
              nuevo_tipoeqid
            );
          });
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    tipoeqcodigo: {
      label: 'Código de Equipo',
      id: '',
      value: '',
    },
    nombreEquipo: {
      label: 'Nombre del Equipo',
      id: '',
      value: '',
    },
    nombreCRM: {
      label: 'Nombre en CRM',
      id: '',
      value: '',
    },
    nombreINET: {
      label: 'Nombre Existencia INET',
      id: '',
      value: '',
    },
    clase: {
      label: 'Clase',
      id: '',
      value: '',
    },
    fechaCrea: {
      label: 'Fecha de Creación',
      id: '',
      value: moment().format('YYYY-MM-DD h:mm:ss'),
    },
    usuarioCrea: {
      label: 'Usuario Creador',
      id: '',
      value: '',
    },
    fechaModifica: {
      label: 'Fecha de Modificación',
      id: '',
      value: '',
    },
    usuarioModifica: {
      label: 'Usuario Modificador',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: 'ACTIVO',
      value: 'ACTIVO',
    },
    seriado: {
      label: 'Seguimiento seriado',
      id: 'Seriado',
      value: true,
    },
    tipoeqid_r: {
      label: 'Tipo Usado Asociado',
      id: 'tipoeqid_r',
      value: '',
    },
    tipoeqcuenta_inet: {
      label: 'Cuenta existencias INET',
      id: 'tipoeqcuenta_inet',
      value: '',
    },
  };
  equipos_totales: any = [];
  plataformas: any = [];
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { id: JSON.parse(localStorage.getItem('user')).id },
      'conecta_matriz_producto/s_crear_equipo'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.id_equipo = Number(data.data.eqid.LISTA[0].max) + 1;
          self.formFields.tipoeqcodigo.value = String(
            Number(data.data.eqcodigo.LISTA[0].max) + 1
          );
          self.formFields.usuarioCrea.value = data.data.usuariocreador.LISTA[0].concat_ws.toUpperCase();
          this.equipos_totales = data.data.total_equipos.LISTA;
          this.plataformas = data.data.plataformas.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.getEquipos();

    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Nombre solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Materno solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }

  addDevice() {
    if (!this.tipoeqcuenta_inet_new || !this.plataforma) {
      this.$snotify.error('Por favor agregue todos los campos');
      return;
    }
    let plataform = this.plataforma;
    let selected = this.plataformas.find((eq: any) => {
      return eq.configid == plataform;
    }).configvalor;
    let newDevice = {
      cuentaInet: this.tipoeqcuenta_inet_new.toString().toUpperCase(),
      plataforma: selected,
      plataformaid: this.plataforma,
    };
    this.loadedSeries.push(newDevice);
    this.clearDevices();
    this.reloadEquipos();
    this.updateFlete();
  }

  clearDevices() {
    this.plataforma = null;
    this.tipoeqcuenta_inet_new = null;
  }

  newList: Array<any> = [];
  alreadyReload: boolean = false;

  reloadEquipos() {
    if (this.loadedSeries.length > 0) {
      this.newList = this.plataformas.filter(
        (eq: any) =>
          !this.loadedSeries.some(serie => serie.configid === eq.configid)
      );
      this.alreadyReload = true;
      return this.newList;
    }
  }

  constructor() {
    super();
    let self = this;
    this.columnDefs = [
      {
        headerName: 'Cuenta INET',
        field: 'cuentaInet',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        resizable: true,
        sortable: true,
        hide: false,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {},
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged(params: any) {}
  loadedSeries: Array<any> = [];

  updateFlete() {
    if (this.loadedSeries.length > 0) {
      this.loadedSeries = this.loadedSeries
        .map((e: any) => {
          return {
            ...e,
            cuentaInet: e.cuentaInet.toString().toUpperCase(),
            plataforma: e.plataforma,
            plataformaid: e.plataformaid,
          };
        })
        .filter((serie, index, self) => {
          const isUnique =
            index ===
            self.findIndex(s => s.plataformaid === serie.plataformaid);

          // Mostrar notificación de error si no es única
          if (!isUnique) {
            this.$snotify.error(
              'Esta plataforma ya fue ingresada para este Equipo',
              { timeout: 3000 }
            );
          }

          return isUnique;
        });
      this.gridApi.setRowData(this.loadedSeries);
    }
  }

  async insertar_cuentasInet(
    cuentaInet: any,
    plataformaid: any,
    nuevo_tipoeqid: any
  ) {
    let self = this;
    this.loadingService.showLoading();

    return fetchReportesSerie(
      {
        cuentaInet,
        plataformaid,
        nuevo_tipoeqid,
      },
      'conecta_matriz_producto/insertar_cuentaInet'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA != '1') {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
}
